<template>
    <div class="header-container">
        <div class="header-box">
            <span class="welcome-title">您好！欢迎来到中原e购</span>
            <span class="time-clock">{{ updateTime }}</span>
            <a href="###" class="login-button" @click="doLogin('login')" v-if="!$store.state.login_status">请登录</a>
            <div class="login-btns" v-else>
                <div>
                    <span style="color: #ea3535">{{
                        $store.state.user_info.memberName
                    }}</span>
                    <span class="logout-btn hover-head-btn" @click="doLogOut">退出</span>
                </div>
                <div class="edit-pass hover-head-btn" @click="editPassword">
                    修改密码
                </div>
                <div class="my-footprint" @mouseenter="enter" @mouseleave="leave">
                    我的足迹
                    <ul class="hide-menu hover-head-btn" v-if="seen">
                        <li>我的足迹</li>
                        <li @click="goPage('/mycollect')">我的收藏</li>
                    </ul>
                </div>

                <div class="help-center hover-head-btn" @click="goPage('/aboutus')">
                    帮助中心
                </div>
            </div>
            <div class="help-center hover-head-btn online_customer pointer" @click="onOnline()">
                <div>在线客服</div>
                <div class="dotted" v-if="isShowDot"></div>
            </div>
            <div class="help-center hover-head-btn online_customer pointer" v-if="$store.state.login_status"
                @click="onRecmmend()">
                <div>e购优选</div>
            </div>
            <div class="help-center hover-head-btn online_customer fc_theme">
                400-900-7689
            </div>
            <div class="help-center hover-head-btn online_customer pointer fc_theme" @click="onJCSJ()">
                <div>在线监察</div>
            </div>
        </div>
        <el-dialog append-to-body custom-class="online_dialog" :visible.sync="onlineVisible"
            width="935px" @close="onClose" @opened="handleDialogOpened">
            <template v-slot:title>
                <div class="online-header">
                    <div class="avatar">
                        <img src="@/assets/images/online/logo.png" />
                    </div>
                    <div class="info">
                        <div class="name">中原e购客服</div>
                        <div class="description">中原e购为您服务</div>
                    </div>
                </div>
            </template>
            <my-online ref="myOnline"></my-online>
        </el-dialog>
        <div class="side-tabs">
            <div class="side-item" v-if="!$store.state.login_status" @click="doLogin('login')">
                <img src="@/assets/images/sidebar/user.png" />
                <p>登录</p>
            </div>
            <div class="side-item" @click="jumpUrl('purchaseList')">
                <img src="@/assets/images/sidebar/cart.png" />
                <p>购物车</p>
            </div>
            <div class="side-item" @click="jumpUrl('mycollect')">
                <img src="@/assets/images/sidebar/collect.png" />
                <p>收藏</p>
            </div>
            <div class="side-item" @click="onOnline()">
                <img src="@/assets/images/sidebar/customer.png" />
                <p>客服</p>
            </div>
            <div class="side-item" @click="onRecmmend()" v-if="$store.state.login_status">
                <img src="@/assets/images/sidebar/super.png" />
                <p>e购优选</p>
            </div>
            <div class="side-item" @click="onPlatform()">
                <img src="@/assets/images/sidebar/platform.png" />
                <p>供应商</p>
                <p>入驻</p>
            </div>
        </div>
    </div>
</template>

<script>
import { logout } from "@/api/login";
import MyOnline from '@/components/online/index.vue'
import jsCookie from 'js-cookie'
export default {
    name: "myHeader",
    data() {
        return {
            updateTime: "",
            seen: false,
            onlineVisible: false,
            isShowDot: false
        };
    },
    components: {
        MyOnline
    },
    watch: {
        '$store.state.isNewMessage': function (newVal, oldVal) {
            if(newVal){
                this.isShowDot=true
            }else{
                this.isShowDot=false
            }
        }
    },
    mounted() {
        localStorage.setItem('onlineDialog',0);
        this.$store.commit("changeIsMessage", 0);
    },
    created() {
        this.addDate();
    },
    methods: {
        //供应商入驻
        onPlatform() {
            let current = this.$router.resolve({
                path: "/platform",
                query:{
                    type:1
                }
            });
            window.open(current.href, "_blank");
        },
        //退出登录
        doLogOut() {
            logout().then(res => {
                if (res.code == 200) {
                    this.$store.commit("changeLoginStatus", false);
                    this.$store.commit("changeUserInfo", {});
                    this.$store.commit("changeIsMessage", 0);
                    jsCookie.remove("token");
                    jsCookie.remove("memberId");
                    jsCookie.remove("memberName");
                    this.$router.push({
                        path: "/login"
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //修改密码
        editPassword() {
            this.$router.push({
                path: "/editPassword"
            });
        },
        //登录
        //在线客服
        onOnline() {
            this.onlineVisible = true;
        },
        handleDialogOpened() {
            localStorage.setItem('onlineDialog',1);
            this.$store.commit("changeIsMessage", 0);
            this.$nextTick(() => {
                // 执行你想要的逻辑
                this.$refs.myOnline.controlScroll();
            });
        },
        //关闭
        onClose() {
            localStorage.setItem('onlineDialog',0);
            this.onlineVisible = false
            // if (this.$globalSocket.socket) {
            //     this.$globalSocket.closeWebsocket();
            // }
        },
        addDate() {
            const nowDate = new Date();
            const date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            };
            const newmonth = date.month > 10 ? date.month : "0" + date.month;
            const day = date.date > 10 ? date.date : "0" + date.date;
            this.updateTime =
                date.year + "\xa0年\xa0" + newmonth + "\xa0月\xa0" + day + "日";
        },
        doLogin(url) {
            this.$router.push({
                name: url,
            });
        },
        doLogOut() {
            logout().then((res) => {
                if (res.success) {
                    if (this.$globalSocket.socket) {
                        this.$globalSocket.closeWebsocket();//退出之后关闭websocket
                    }
                    //this.$store.commit("changeWsMemberId", '');
                    this.$cookie.set("wsmemberId", '')
                    //sessionStorage.setItem("wsmemberId", '');
                    this.$toast(res.message);
                    if (this.$route.path == "/home") {
                        //this.$router.go(0);
                        location.reload();
                    } else {
                        this.$router.push({
                            name: "home",
                        });
                    }
                    this.$store.commit("changeLogin", 0);
                    // console.log(this.$store.state.login_status);
                    this.userToken = '';
                    // 将用户token保存到vuex中
                    this.$store.commit("changeLogintwo", {
                        Authorization: this.userToken,
                    });
                    //清除比价数据
                    localStorage.removeItem("contrastgoods");
                    if (localStorage.getItem("shenpiliu")) {
                        localStorage.removeItem("shenpiliu");
                    }
                    //清除是否打开在线客服 弹出框
                    localStorage.removeItem('onlineDialog');
                    this.$store.commit("changeIsMessage", 0);
                }
            });
        },
        // 修改密码
        editPassword() {
            this.$router.push({
                name: "revisePwd",
            });
        },
        enter() {
            this.seen = true;
        },
        leave() {
            this.seen = false;
        },
        goPage(path) {
            this.$router.push({
                path: path,
            });
        },
        //推荐
        onRecmmend() {
            this.$router.push({
                path: '/recommend',
            });
        },
        jumpUrl(url) {
            if (jsCookie.get("Authorization")) {//当前处于登录状态
                this.$router.push({
                    name: url
                });
            } else {
                this.$router.push({
                    path: '/login'
                });
            }
        },
        onJCSJ(){
          location.href = "http://zyecp.com/admin/loginJCSJ";
        }
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
.header-container {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #f1f1f1;
    color: #666666;
    font-size: 12px;

    .header-box {
        width: 1200px;
        height: 30px;
        margin: 0 auto;
        // border: 1px solid red;
        display: flex;
        flex-direction: row;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;

        .welcome-title {
            margin-right: 30px;
        }

        .time-clock {
            color: #333333;
            padding-left: 20px;
            background-size: 14px;
            background: url(../../../assets/images/indexicon/clock.png) 0 center no-repeat;
        }

        .login-button {
            display: block;
            color: #ea3535;
            margin-left: auto;
            box-sizing: border-box;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }

        .login-btns {
            margin-left: auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            .logout-btn {
                margin-right: 46px;
            }

            .my-footprint {
                background: url(../../../assets/images/indexicon/topbar_icon_1.png) 54px 14px no-repeat;
                padding-right: 24px;
                position: relative;
                margin: 0 28px;
                position: relative;

                .hide-menu {
                    width: 100%;
                    background: #ffffff;
                    z-index: 999;
                    background: #ffffff url(../../../assets/images/indexicon/topbar_icon_2.png) 64px 14px no-repeat;
                    position: absolute;
                    left: -10px;
                    top: 0;
                    box-shadow: 0 4px 6px 0px #adadad6b;
                    border-bottom-right-radius: 2px;
                    overflow: hidden;
                    border-bottom-left-radius: 2px;
                    padding-left: 10px;

                    li {
                        height: 30px;
                        width: 100%;
                        color: #333;

                        &:hover {
                            color: #ea3535;
                        }
                    }
                }
            }

            .hover-head-btn {
                cursor: pointer;

                &:hover {
                    color: #ea3535;
                }
            }
        }

        .online_customer {
            margin-left: 28px;
            position: relative;

            .dotted {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: red;
                position: absolute;
                top: 5px;
                right: -3px;
            }

            :hover {
                color: #ea3535;
            }
        }
    }
}
/deep/ .online_dialog {
    z-index: 1000;
    .el-dialog__header {
        background: #fafafa;
        padding: 8px 10px;
    }

    .el-dialog__body {
        padding: 0;
    }
}

.online-header {
    width: 100%;
    background: #fafafa;
    box-sizing: border-box;
    display: flex;

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 3px;
        overflow: hidden;
        margin-right: 10px;
        background: #e63535;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .info {
        padding-top: 3px;

        .name {
            font-size: 14px;
            color: #343036;
        }

        .description {
            color: #a1a6af;
            font-size: 12px;
        }
    }
}

.side-tabs {
    margin-top: -76px;
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 1999;
    transform: translateY(-50%);

    div {
        // height: 47px;
        margin-bottom: 2px;
        position: relative;
        width: 48px;
        border-radius: 4px 0 0 4px;
        background: #e63535;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding:2px 0;

        img {
            max-width: 24px;
            margin-bottom: 4px;
        }

        p {
            height: 15px;
            line-height: 15px;
            font-size: 12px;
            color: #FFFFFF;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/myHeader.vue